<ng-container>
  <div class="rv-flex gap-medium flex-fs flex-end" *ngIf="data as result">
    <button-dropdown #addFilterDropdown [icon]="'Plus'">
      <ng-container button-content>Add filter</ng-container>
      <div class="rv-card surface-0 expand-option">
        <single-select
          [disableArray]="_.getDisableArray()"
          [options]="_.options"
          (selectedOptionChange)="
            addFilterDropdown.close(); _.addFilter($event)
          "
        >
        </single-select>
      </div>
    </button-dropdown>
    <div
      *ngFor="let filter of _.filters; let i = index"
      [attr.data-index]="i"
      class="rv-flex flex-end flex-nowrap"
    >
      <multi-select-dropdown-field
        class="rv-flex-grow-auto super-filter-multiselect"
        *ngIf="filter.optionType === 'dropdown'"
        label="{{ filter.title }}"
        [placeholder]="'Select filter'"
        [options]="_.getMultiSelectOptions(filter)"
        [filterable]="true"
        [value]="filter.valueArr ?? []"
        (valueChange)="_.setFilterSelection($event, filter, i)"
        (dropdownStateChange)="_.onMultiSelectStateChange($event, i)"
        [maxElements]="500"
      ></multi-select-dropdown-field>
      <multi-select-number-comparator
        *ngIf="filter.optionType === 'number'"
        label="{{ filter.title }}"
        [selectedOption]="filter.numberValue.comparator ?? 'Greater than'"
        [value]="filter.numberValue.value ?? 0"
        (onChange)="_.numberValueChange($event, filter, i)"
        class="rv-flex-grow-auto"
      ></multi-select-number-comparator>
      <button
        rivButton
        variant="ghost"
        (click)="_.removeFilter(i)"
        [icon]="'X'"
      ></button>
    </div>
  </div>
</ng-container>
